import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { ICompany } from 'src/app/interfaces/company';
import { BIDService } from 'src/app/services/common/bid.service';
//import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { HttpHeaders } from '@angular/common/http';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CIDService } from 'src/app/services/common/cid.service';

@Component({
  selector: 'app-placement-search',
  templateUrl: './placement-search.component.html',
  styleUrls: ['./placement-search.component.css']
})
export class PlacementSearchComponent implements OnInit {
  isOwner: boolean;
  form: FormGroup;
  eduPackageList: IEducationPackage;
  companyList: ICompany[];
  branchList: IBranch[];

  constructor(
    private fb: FormBuilder,
    private eduPackageService: EducationPackageService,
    private bidService: BIDService,
    private cidService: CIDService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private dialog: MatDialogRef<PlacementSearchComponent>) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.getEduPackage();
    this.getCompanyList();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null, Validators.compose([Validators.required])],
      BranchEncryptId: [null, Validators.compose([Validators.required])],
      FullName: [null],
      NationalCode: [null],
      PackageId: [null],
      LevelInfoName: [null],
      TeacherName: [null],
      PlacementDateFrom: [null],
      PlacementDateTo: [null],
      ReservedTimeFrom: [null],
      ReservedTimeTo: [null],
      PlacementReservationStatusId: [null],
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);

      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    if (this.isOwner)
      this.cidService.setCID(e.value);
    this.getBranchList(e.value);
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  submit(data: any) {
    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }

}
